import React, { useEffect, useState } from 'react';
import '@arianee/arn-components'; // Register ARN web components
import Button from '@ui/button/Button';
import { useTranslation } from 'react-i18next';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import ModalDialog from '@ui/modal/ModalDialog';
import QRCode from 'react-qr-code';
import useBreakpoint from '@common/utils/useBreakpoint';
const DownloadApp = (props) => {
    const { t } = useTranslation();
    const [openDownloadDialog, setOpenDownloadDialog] = useState(false);
    useEffect(() => {
        if (document.documentElement.style.scrollBehavior !== 'smooth' && window.pageAction !== 'Search-Show') {
            document.documentElement.style.scrollBehavior = 'smooth';
        }
    }, []);
    const currentBreakpoint = useBreakpoint();
    const [isDesktop, setIsDesktop] = useState(false);
    useEffect(() => {
        if (currentBreakpoint >= window.mqObj.md) {
            setIsDesktop(true);
        }
        else {
            setIsDesktop(false);
        }
    }, [currentBreakpoint]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: "button", cls: JSON.parse(props.classes), onClick: (e) => {
                setOpenDownloadDialog(true);
            }, ariaHaspopup: "dialog" }, props.text),
        React.createElement(ModalDialog, { overlayClassName: "mobile-visible", contentLabel: t('label.downloadapp'), className: "download-app__modal download-app__modal--small", isOpen: openDownloadDialog, role: "dialog", onRequestClose: () => {
                setOpenDownloadDialog(false);
            } },
            React.createElement(Tabs, null,
                React.createElement(TabList, { className: "react-tabs__tab-list" },
                    React.createElement(Tab, null, t('label.os.ios.title')),
                    React.createElement(Tab, null, t('label.os.android.title'))),
                React.createElement(TabPanel, null,
                    React.createElement("p", { className: "primary-xs mt-24 mb-24" }, t('label.os.ios.download')),
                    React.createElement(QRCode, { size: 100, className: "download-app__download-app-qrcode", value: "https://apps.apple.com/app/moncler/id1526276232" })),
                React.createElement(TabPanel, null,
                    React.createElement("p", { className: "primary-xs mt-24 mb-24" }, t('label.os.android.download')),
                    React.createElement(QRCode, { size: 100, className: "download-app__download-app-qrcode", value: "https://play.google.com/store/apps/details?id=com.moncler.ecommerce.store" }))))));
};
export default DownloadApp;
